import axios from "axios";
import { ApiError } from "../../Models/ApiError";
import { HandleError } from "../../Helpers/ErrorHandler";
import { Customer, CustomerCreateRequest, OrderItemPrice, SalesOrderCreateRequest, SalesOrderCreateResponse } from "../../Models/SalesOrder";

const API_URL = process.env.REACT_APP_API_URL;

const call = <T,>(request: Promise<{ data: T }>): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    request
      .then((resp) => resolve(resp.data))
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        reject(apiErr);
      });
  });
};

//customers matching every word typed, in alphabetical order; blank lists them all from A
export const searchCustomersAPI = (search: string, serverUrl: string, dbKey: string): Promise<Customer[]> =>
  call(axios.get<Customer[]>(`${API_URL}salesorder/customers?search=${encodeURIComponent(search)}&serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`));

export const createCustomerAPI = (model: CustomerCreateRequest, serverUrl: string, dbKey: string): Promise<Customer> =>
  call(axios.post<Customer>(`${API_URL}salesorder/customers?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model));

//the customer's price for an item at a qty (sell packs) - the site's pda_ProductList customer price when it has
//one, otherwise the customer's price band. Stock codes can contain '/', so they go in the query string.
export const getOrderItemPriceAPI = (stockCode: string, customer: Customer, qty: number, serverUrl: string, dbKey: string): Promise<OrderItemPrice> =>
  call(
    axios.get<OrderItemPrice>(
      `${API_URL}salesorder/price?stockCode=${encodeURIComponent(stockCode)}&companyNo=${customer.companyNo}&accountNo=${customer.accountNo}&priceBand=${encodeURIComponent(customer.accountPriceBand || "")}&qty=${qty}&serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`,
    ),
  );

//posts the order to eSuite as an SOR
export const createSalesOrderAPI = (model: SalesOrderCreateRequest, serverUrl: string, dbKey: string): Promise<SalesOrderCreateResponse> =>
  call(axios.post<SalesOrderCreateResponse>(`${API_URL}salesorder?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model));
